import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["viewBox"]
const _hoisted_2 = { "clip-path": "url(#clip0_11969_67690)" }
const _hoisted_3 = ["fill"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.27273 2.72727V5.09091C5.27273 5.13913 5.25357 5.18538 5.21947 5.21947C5.18538 5.25357 5.13913 5.27273 5.09091 5.27273H2.72727C2.53439 5.27273 2.3494 5.34935 2.21301 5.48574C2.07662 5.62213 2 5.80712 2 6C2 6.19288 2.07662 6.37787 2.21301 6.51426C2.3494 6.65065 2.53439 6.72727 2.72727 6.72727H5.09091C5.13913 6.72727 5.18538 6.74643 5.21947 6.78053C5.25357 6.81462 5.27273 6.86087 5.27273 6.90909V9.27273C5.27273 9.46561 5.34935 9.6506 5.48574 9.78699C5.62213 9.92338 5.80712 10 6 10C6.19288 10 6.37787 9.92338 6.51426 9.78699C6.65065 9.6506 6.72727 9.46561 6.72727 9.27273V6.90909C6.72727 6.86087 6.74643 6.81462 6.78053 6.78053C6.81462 6.74643 6.86087 6.72727 6.90909 6.72727H9.27273C9.46561 6.72727 9.6506 6.65065 9.78699 6.51426C9.92338 6.37787 10 6.19288 10 6C10 5.80712 9.92338 5.62213 9.78699 5.48574C9.6506 5.34935 9.46561 5.27273 9.27273 5.27273H6.90909C6.86087 5.27273 6.81462 5.25357 6.78053 5.21947C6.74643 5.18538 6.72727 5.13913 6.72727 5.09091V2.72727C6.72727 2.53439 6.65065 2.3494 6.51426 2.21301C6.37787 2.07662 6.19288 2 6 2C5.80712 2 5.62213 2.07662 5.48574 2.21301C5.34935 2.3494 5.27273 2.53439 5.27273 2.72727Z",
  fill: "white"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_11969_67690" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "14",
      height: "14",
      fill: "white"
    })
  ])
], -1)

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'increaseIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "currentColor",
  },
  width: {
    type: Number as PropType<number>,
    default: 14,
  },
  height: {
    type: Number as PropType<number>,
    default: 14,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: "17px",
    height: "17px",
    viewBox: `0 0 ${__props.width} ${__props.height}`,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        d: "M11.855 5.64399L6.35497 0.143993C6.30849 0.0971287 6.25319 0.0599315 6.19226 0.0345472C6.13133 0.00916287 6.06598 -0.00390625 5.99997 -0.00390625C5.93396 -0.00390625 5.86861 0.00916287 5.80768 0.0345472C5.74675 0.0599315 5.69145 0.0971287 5.64497 0.143993L0.144969 5.64399C0.0981053 5.69047 0.0609081 5.74577 0.0355238 5.8067C0.0101394 5.86763 -0.00292969 5.93299 -0.00292969 5.99899C-0.00292969 6.065 0.0101394 6.13035 0.0355238 6.19128C0.0609081 6.25221 0.0981053 6.30751 0.144969 6.35399L5.64497 11.854C5.69145 11.9009 5.74675 11.9381 5.80768 11.9634C5.86861 11.9888 5.93396 12.0019 5.99997 12.0019C6.06598 12.0019 6.13133 11.9888 6.19226 11.9634C6.25319 11.9381 6.30849 11.9009 6.35497 11.854L11.855 6.35399C11.9018 6.30751 11.939 6.25221 11.9644 6.19128C11.9898 6.13035 12.0029 6.065 12.0029 5.99899C12.0029 5.93299 11.9898 5.86763 11.9644 5.8067C11.939 5.74577 11.9018 5.69047 11.855 5.64399Z",
        fill: __props.color
      }, null, 8, _hoisted_3),
      _hoisted_4
    ]),
    _hoisted_5
  ], 8, _hoisted_1))
}
}

})